import React from 'react';
import { makeStyles, Popper } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles({
  popper: {
    '& .MuiAutocomplete-paper': {
      border: '1px solid #cad8ff',
      borderRadius: '0px',
      fontFamily: 'Poppins',
      fontSize: '14px',
      marginBottom: '0px'
    },
    '& .MuiAutocomplete-paper .MuiAutocomplete-listbox': {
      maxHeight: '256px',
      padding: '0px'
    },
    '& .MuiAutocomplete-paper .MuiAutocomplete-option': {
      background: 'white',
      display: 'block',
      overflow: 'hidden',
      padding: '5.5px 12px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  root: {
    '& .MuiAutocomplete-input': {
      fontFamily: 'Poppins',
      fontSize: '12px'
    },
    '& .MuiAutocomplete-input::placeholder': {
      color: 'black',
      opacity: '1'
    },
    '& .MuiAutocomplete-input:focus::placeholder': {
      opacity: '0.4'
    },
    '& .MuiAutocomplete-inputRoot': {
      padding: '3.5px 34px 3.5px 5px'
    },
    '& .MuiAutocomplete-inputRoot .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #cad8ff',
      borderRadius: '10px'
    },
    background: 'white',
    borderRadius: '10px',
    height: '40.25px',
    width: '100%'
  }
});

const AutocompleteSelect = ({
  onSelect,
  onViewAll,
  placeholderValue,
  options,
  styles = {},
  id = '',
  getOptionLabel = (option) => option?.name,
  multiple = false
}) => {
  const classes = useStyles();

  function equalityTest(option, values) {
    if (Array.isArray(values)) {
      return values.some((value) => option.id === value.id);
    }

    return option === values || option?.id === values?.id;
  }

  return (
    <Autocomplete
      classes={{ popper: classes.popper, root: classes.root }}
      clearOnEscape
      disableClearable
      getOptionLabel={getOptionLabel}
      getOptionSelected={equalityTest}
      id={id}
      multiple={multiple}
      onChange={(_event, value) => onSelect(value)}
      options={options}
      PopperComponent={(props) => {
        return (
          <Popper {...props} placement="bottom-start">
            {props.children}
            {typeof onViewAll === 'function' && (
              <button
                onMouseDown={onViewAll}
                style={{
                  background: '#5564F8',
                  border: 'none',
                  borderRadius: '0px 0px 14px 14px',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'block',
                  fontFamily: 'Poppins',
                  margin: '0',
                  padding: '6px',
                  textAlign: 'center',
                  width: '100%'
                }}
                type="button"
              >
                See All
              </button>
            )}
          </Popper>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholderValue} variant="outlined" />
      )}
      style={styles}
      value={multiple ? [] : null}
    />
  );
};

export default AutocompleteSelect;
